export enum SupportTicketAssigneeType {
  User = "USER",
  Ai = "AI",
  ChatFlow = "CHAT_FLOW",
}
